import { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button, Box } from "@mui/material";
import AddAttributeModal from "./AddAttributeModal";

const stickyHeaderStyle = {
  position: "sticky",
  top: 0,
  background: "#0D59A7",
  color: "white",
  zIndex: 1,
};

export default function MapAssetAttributeModal({ open, onClose, assetType }) {
  const [allAttributes, setAllAttributes] = useState([]);
  const [checkedMap, setCheckedMap] = useState({});
  const [openAddAttr, setOpenAddAttr] = useState(false);
  const [loading, setLoading] = useState(false);

  const token = sessionStorage.getItem("token");
  const BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (open && assetType?.identy) {
      fetchAllAttributes();
      fetchMappedAttributes();
    }
  }, [open, assetType]);

  const fetchAllAttributes = async () => {
    setLoading(true);
    const res = await axios.get(`${BASE}/api/attribute`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setAllAttributes(res.data.response || []);
    setLoading(false);
  };

  const fetchMappedAttributes = async () => {
    try {
      const res = await axios.get(
        `${BASE}/api/attribute/assets-type/${assetType.identy}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const mapped = res.data.response?.attributes || [];
      const map = {};
      mapped.forEach((a) => (map[a.attributeIdenty] = true));
      setCheckedMap(map);
    } catch {
      setCheckedMap({});
    }
  };

  const toggleCheck = (id) => {
    setCheckedMap((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const updateMapping = async () => {
    const payload = {
      assetTypeIdenty: assetType.identy,
      attributeIdenties: Object.keys(checkedMap).filter((k) => checkedMap[k]),
    };

    await axios.post(`${BASE}/api/attribute/assets-type/map-asset-attribute`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    alert("Mapping updated successfully");
    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            width: "80%",
            maxWidth: 900,
            bgcolor: "white",
            borderRadius: 2,
            p: 2,
            mx: "auto",
            mt: "5%",
            maxHeight: "85vh",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-0">
              Map Attributes – <span className="text-primary">{assetType?.typeName}</span>
            </h5>
            <Button size="small" variant="contained" onClick={() => setOpenAddAttr(true)}>
              + Add New Attribute
            </Button>
          </div>

          {/* Table */}
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <table className="table table-bordered table-hover shadow-sm">
              <thead className="table-primary">
                <tr>
                  <th style={stickyHeaderStyle}>Select</th>
                  <th style={stickyHeaderStyle}>Attribute Key</th>
                  <th style={stickyHeaderStyle}>Attribute Label</th>
                  <th style={stickyHeaderStyle}>Notes</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="4" className="text-center">
                      Loading attributes...
                    </td>
                  </tr>
                )}

                {!loading && allAttributes.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No attributes found
                    </td>
                  </tr>
                )}

                {!loading &&
                  allAttributes.map((a) => (
                    <tr key={a.identy}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          checked={!!checkedMap[a.identy]}
                          onChange={() => toggleCheck(a.identy)}
                        />
                      </td>
                      <td>{a.attributeKey}</td>
                      <td>{a.attributeLabel}</td>
                      <td>{a.notes || "-"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="d-flex justify-content-end gap-2 mt-2">
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="contained" onClick={updateMapping}>
              Update Mapping
            </Button>
          </div>
        </Box>
      </Modal>

      <AddAttributeModal
        open={openAddAttr}
        onClose={() => setOpenAddAttr(false)}
        onCreated={() => {
            setOpenAddAttr(false);
            fetchAllAttributes();   // refresh list immediately
        }}
        />
    </>
  );
}